<template>
  <div v-if="explain" style="display: flex;overflow: auto;height: 100%">
    <div class="outline">
      <div style="height: 314px">
        <img :src="fh" @click="returnto" class="back" style="left: -2px">
        <span class="title">健康状态辨识总提纲解释说明</span>
      </div>
      <div class="explain-content">
        <div v-for="(item , index) in explain" :key="index">
          {{item}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import fh from '../../assets/img/report/fh_icon.png';
  import { getHealthExplain } from '@/api/report.js';
  export default {
    name: "femaleoutline",
    data(){
      return{
        explain: null,
        reportData:null,
        definition:'',
        fh:fh,
        id:'',
      }
    },
    created() {
      this.getExplainData()
    },
    computed: {
      access(){
        return access
      }
    },
    methods:{
      getExplainData(){
        getHealthExplain().then(res =>{
            if(res && res.status_code === 10000 && res.data) {
              this.explain = res.data.content;
            }
          }
        )
      },
      returnto(){
        this.$router.push({name:'Femaleexplain', params: {reportData: this.reportData,definition:this.definition,id:this.id}})
      }
    },
    beforeMount(){
      this.reportData = this.$route.params.reportData
      this.definition = this.$route.params.definition
      this.id = this.$route.params.id
    }
  }
</script>

<style scoped>
  .outline{
    width:100%;
    height:100%;
    padding: 0 0 0 52px;
    background:url("../../assets/img/report/bj1.png");
    background-size:cover;
    overflow:hidden;
  }
  ::-webkit-scrollbar{
    display: none;
  }
  .title{
    font-size: 48px;
    color:#00FEFB;
    font-family:TITLE;
    width:666px;
    height:111px;
    background:url("../../assets/img/report/jssm_icon.png") no-repeat;
    text-align:center;
    line-height:111px;
    background-size:100% 100%;
    position: absolute;
    left: 0;
    top: 83px;
    right: 0;
    margin: 0 auto;
  }
  .back{
    position:relative;
    left:49px;
    top:105px;
    width: 152px;
    height: 82px;
  }
  .explain-content{
    position:relative;
    width:838px;
    height:605px;
    background:url("../../assets/img/report/jssmbj_icon.png") no-repeat;
    background-size:100% 100%;
    margin-top:50px;
    margin-right:50px;
    padding:130px 69px;
    color:#ffffff;
    font-size:30px;
    line-height:52px;
    text-indent:58px;
  }
</style>
